import { ElementRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { catchError, EMPTY, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import * as i0 from "@angular/core";
import * as i1 from "../../features/fund-universe-quartile-chart/components/fund-universe-quartile-chart/fund-universe-quartile-chart.component";
function FundUniverseQuartileChartPageComponent_For_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-fund-universe-quartile-chart", 1);
    i0.ɵɵlistener("stateChangeHandler", function FundUniverseQuartileChartPageComponent_For_2_Template_ycn_fund_universe_quartile_chart_stateChangeHandler_0_listener($event) { const ɵ$index_3_r2 = i0.ɵɵrestoreView(_r1).$index; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.savePreference($event, ɵ$index_3_r2)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const preference_r4 = ctx.$implicit;
    i0.ɵɵproperty("targetSecurities", preference_r4.targetSecurities)("metric", preference_r4.metric)("securitylistName", preference_r4.securitylistName)("securityGroup", preference_r4.securityGroup)("zoom", preference_r4.zoom)("frequency", preference_r4.frequency)("includeBenchmark", preference_r4.includeBenchmark);
} }
const USER_PREFERENCE_NAME = 'fund_universe_quartile_chart';
export class FundUniverseQuartileChartPageComponent {
    constructor() {
        this.userChartPreferences = [];
        this.USER = window.USER;
        /** What was last asked for, so a change that leaves the saved shape alone costs no request. */
        this.savedPreferences = [];
        /** Each desired preference list, written one at a time with the stale write dropped. */
        this.preferencesToWrite = new Subject();
        this.accountsService = inject(AccountsService);
        this.eltRef = inject(ElementRef);
        this.userChartPreferences = JSON.parse(this.eltRef.nativeElement.getAttribute('chart-preferences')) ?? [];
        this.savedPreferences = this.userChartPreferences.map((preference) => this.toPreference(preference));
        // If a control is updated prior to when an initial PUT request finishes, the old request is dropped
        // and the new one is sent.
        this.preferencesToWrite
            .pipe(switchMap((preferences) => this.accountsService
            .putUserPreferences({ [USER_PREFERENCE_NAME]: preferences })
            .pipe(catchError(() => EMPTY))), takeUntilDestroyed())
            .subscribe();
    }
    savePreference(state, index) {
        if (!this.USER.authenticated || !this.savedPreferences.length)
            return;
        const preference = this.toPreference(state);
        if (JSON.stringify(preference) === JSON.stringify(this.savedPreferences[index]))
            return;
        this.savedPreferences = this.savedPreferences.map((saved, i) => (i === index ? preference : saved));
        this.preferencesToWrite.next(this.savedPreferences);
    }
    /**
     * Given a chart's state, returns it as chart preferences.
     * The universe and the target information is left empty because they come from the selected security,
     * not the saved preferences.
     */
    toPreference(state) {
        return {
            zoom: state.zoom,
            // A metric with no history carries no frequency, which is saved as null rather than ''.
            frequency: state.frequency || null,
            metric: state.metric,
            include_benchmark: state.includeBenchmark,
            securitylist_name: '',
            security_group: '',
            target_security_ids: [],
        };
    }
}
FundUniverseQuartileChartPageComponent.ɵfac = function FundUniverseQuartileChartPageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundUniverseQuartileChartPageComponent)(); };
FundUniverseQuartileChartPageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundUniverseQuartileChartPageComponent, selectors: [["ycn-fund-universe-quartile-chart-page"]], standalone: false, decls: 3, vars: 0, consts: [[3, "targetSecurities", "metric", "securitylistName", "securityGroup", "zoom", "frequency", "includeBenchmark"], [3, "stateChangeHandler", "targetSecurities", "metric", "securitylistName", "securityGroup", "zoom", "frequency", "includeBenchmark"]], template: function FundUniverseQuartileChartPageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "main");
        i0.ɵɵrepeaterCreate(1, FundUniverseQuartileChartPageComponent_For_2_Template, 1, 7, "ycn-fund-universe-quartile-chart", 0, i0.ɵɵrepeaterTrackByIndex);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵrepeater(ctx.userChartPreferences);
    } }, dependencies: [i1.FundUniverseQuartileChartComponent], encapsulation: 2 });
